/**
 * The building blocks every tile settings panel is laid out with — the report
 * panel and the note panel alike — so the two read as one kind of panel.
 */
import type { ReactNode } from 'react';
import { Label } from '@/components/ui/label';

/** One labelled block of a settings panel. */
export function SettingsSection({
  label,
  htmlFor,
  muted = false,
  children,
}: {
  label: string;
  htmlFor?: string;
  muted?: boolean;
  children: ReactNode;
}) {
  return (
    // `minmax(0, 1fr)`: a grid item is otherwise as wide as its content, and a
    // long report name then pushes the panel sideways instead of truncating.
    <section
      className={`grid grid-cols-[minmax(0,1fr)] gap-2 px-6 py-4 ${muted ? 'opacity-60' : ''}`}
    >
      {htmlFor ? (
        <Label htmlFor={htmlFor}>{label}</Label>
      ) : (
        <h3 className="font-medium text-sm">{label}</h3>
      )}
      {children}
    </section>
  );
}

/** The quiet line under a field. */
export function SettingsHint({ children }: { children: ReactNode }) {
  return <p className="text-muted-foreground text-xs">{children}</p>;
}
